import React, { useState, useEffect, useContext } from "react";
import "./SubModalityWithView.css";
import { TextField } from "@fluentui/react";
import CustomToolTipHost from "./CustomToolTipHost/CustomToolTipHost";
import themeContext from "../context/theme/ThemeContext";



const SubModalityWithView = (props) => {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [warning, setWarning] = useState("");
  const [submodalities, setSubmodalities] = useState([]);
  const [isCustomInputVisible, setIsCustomInputVisible] = useState(false);

  const { getThemeColor,themeName,getScrollBarStyleForTheme } = useContext(themeContext);

  useEffect(() => {
    const submodalities = props.subModalityList? props.subModalityList : [];
    setSubmodalities(submodalities);
  }, [props.subModalityList]);

  useEffect(() => {
    if(submodalities.length != 0){
      const flattened = submodalities.flatMap(sub => {
        if (sub.groups && sub.groups.length > 0) {
          return sub.groups.map(group => ({
            id: group.id,
            name: sub.serviceName,
            view: group.name,
            value: group.value,
            side: group.side,
            priority: group.priority,
            special: sub.special
          }));
        } else {
          return [{
            id: sub.id,
            name: sub.serviceName,
            view: null,
            value: null,
            side: null,
            priority: null,
            special: sub.special
          }];
        }
      });

      const initiallySelected = flattened.filter(item =>
        (props.selectedSubModalityIds || []).includes(item.id)
      );
      if ((props.selectedSubModalityIds || []).includes(-1) && props.customDescription) {
        initiallySelected.push({
          id: -1,
          name: props.customDescription.trim(),
          value: props.customDescription.trim(),
          view: null,
          special: 0,
          priority: 999
        });
      }
      console.log(initiallySelected);
      setSelected(initiallySelected);
    }
  }, [submodalities]);

  const isGroupSelected = (groupId) => {
    return selected.some(item => item.id === groupId);
  };
  
  const isSubmodalitySelected = (sub) => {
    if (sub.groups && sub.groups.length > 0) {
      return sub.groups.some(group => isGroupSelected(group.id));
    } else {
      return selected.some(item => item.id === sub.id);
    }
  };
  

  useEffect(()=>{
    if (!selected || selected.length === 0) return;
    
    if (selected.length === 1 && selected[0].id === -1) {
      props.setChoosenSubModality(-1);
      return;
    }
    
    const submodalityItems = selected.filter(item => item.id !== -1); // ignore custom
    if (submodalityItems.length === 0) return;

    const specialItems = submodalityItems.filter(item => item.special === 1);
    const candidates = specialItems.length > 0 ? specialItems : submodalityItems;

    const withViews = candidates.filter(item => item.view != null);
    let chosen;

    if (withViews.length > 0) {
      const withPriority = withViews.filter(item => item.priority != null);
      chosen = withPriority.length > 0
        ? withPriority.reduce((min, item) => item.priority < min.priority ? item : min)
        : withViews[0];
    } else {
      const withPriority = candidates.filter(item => item.priority != null);
      chosen = withPriority.length > 0
        ? withPriority.reduce((min, item) => item.priority < min.priority ? item : min)
        : candidates[0];
    }

    props.setChoosenSubModality(chosen.id);
    
  }, [selected])

  const handleSelect = (name, view, id, value, side, special, priority) => {
    const exists = selected.some(item => item.id === id);

    const isCustomSelected = selected.some(item => item.id === -1);

    if (exists) {
      setWarning("");
      const newSelected = selected.filter(item => item.id !== id);
      setSelected(newSelected);
      props.setSelectedSubModalityIds(newSelected.map(item => item.id));
    } else if (selected.length < 10) {
      let newSelected = [...selected];

      setWarning("");
      newSelected.push({ id, name, view, value, side, special, priority });
      setSelected(newSelected);
      props.setSelectedSubModalityIds(newSelected.map(item => item.id));
      
    } else {
      setWarning("You can only select up to 10 submodalities.");
    }
  };
  
  const generateDescription = () => {
    const grouped = [];
    const submodalityItems = selected.filter(item => item.id !== -1);
    const customItems = selected.filter(item => item.id === -1);

    submodalityItems.forEach(({ name, view, value, side }) => {
      let entry = grouped.find(item => item.name === name);
      if (!entry) {
        entry = { name, beforeViews: [], afterViews: [], isCustom: false };
        grouped.push(entry); // only push once
      }

      if (view) {
        if (side === 1 && !entry.beforeViews.includes(value)) {
          entry.beforeViews.push(value);
        } else if (side === 0 && !entry.afterViews.includes(value)) {
          entry.afterViews.push(value);
        }
      }
    });

    const subDescription = grouped.map(({ name, beforeViews, afterViews }) => {
      const before = beforeViews.length ? `${beforeViews.join("/")}` : "";
      const after = afterViews.length ? `${afterViews.join("/")}` : "";
      if (before && after) return `${before} ${name} ${after}`;
      if (before) return `${before} ${name}`;
      if (after) return `${name} ${after}`;
      return name;
    }).join(", ");

    const customDescription = customItems.map(item => item.name).join(", ");

    const fullDescription = subDescription
      ? customDescription
        ? `${subDescription} | ${customDescription}`
        : subDescription
      : customDescription;

    props.setStudyDescription(fullDescription);
    return fullDescription;
  };

  const handleCustomInputSubmit = () => {
    let trimmed = props.customDescription ? props.customDescription.trim() : "";
    if (trimmed.length > 50) {
      setWarning("Custom description cannot exceed 50 characters.");
      return;
    }
    trimmed = trimmed.replace(/\|/g, "");

    setWarning(""); 
    if (trimmed) {
      const alreadySelectedCustom = selected.some(item => item.id === -1);
      if (!alreadySelectedCustom) {
        const newSelected = [...selected, { id: -1, name: trimmed, value: trimmed, view: null, special: 0, priority: 999 }];
        setSelected(newSelected);
        props.setSelectedSubModalityIds(newSelected.map(item => item.id));
      } else {
        const newSelected = selected.map(item => item.id === -1 ? { ...item, name: trimmed, value: trimmed } : item);
        setSelected(newSelected);
        props.setSelectedSubModalityIds(newSelected.map(item => item.id));
      }
    }else{
      const newSelected = selected.filter(item => item.id !== -1);
      setSelected(newSelected);
      props.setSelectedSubModalityIds(newSelected.map(item => item.id));  
    }
    setIsCustomInputVisible(false);
  };

  return (
    <div className="multi-select-container" data-theme={themeName}>
        <div className="description-box">
          <label style={{ color: getThemeColor("primary-color") }} className="upload-history-body-label">Study Description:&nbsp;&nbsp;</label>
          {selected.length > 0 || props.customDescription ? (
            <span style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              width: '80%',
              display: 'block',
              color: getThemeColor("primary-color")
            }}>
          <CustomToolTipHost content={generateDescription() || "—"} id="error-des">      
              {generateDescription() || "—"}
          </CustomToolTipHost></span>
          ): (<div>-</div>)}
        </div>

      <div className="options-section common-modal-scroll">
        {submodalities.length === 0 ? (
          <div className="no-results">No submodality found.</div>
        ) : (
          submodalities.map(sub => (
            <div className="tag-with-views" key={sub.id}>
              {sub.groups && sub.groups.length > 0 ? (
                <div className="view-buttons">
                  <div className={`tag ${isSubmodalitySelected(sub) ? "active" : ""} ${sub.special == 1 ? "special" : ""}`}>
                    {isSubmodalitySelected(sub) && <span>✓</span>}{sub.serviceName}
                    <div className="view-list btn-group" role="group">
                      {sub.groups.map(group => (
                        <button
                          key={group.id}
                          className={`btn btn-secondary view-btn ${isGroupSelected(group.id) ? "selected" : ""} ${sub.special == 1 ? "special" : ""}`}
                          onClick={() => handleSelect(sub.serviceName, group.name, group.id, group.value, group.side, sub.special, group.priority)}
                        >
                          {group.name}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`tag ${isSubmodalitySelected(sub) ? "active" : ""}  ${sub.special == 1 ? "special" : ""}`}
                  onClick={() => handleSelect(sub.serviceName, null, sub.id, null, null, null, null)}
                >
                  {isSubmodalitySelected(sub) && <span>✓</span>}{sub.serviceName}
                </div>
              )}
            </div>
          ))
        )}

        {submodalities.length !== 0 && (
          <>
            {!isCustomInputVisible && (
              props.customDescription?.trim() ? (
                <div className="tag active editable" onClick={() => setIsCustomInputVisible(true)}>
                  <span>✓</span> {props.customDescription} <span className="edit-icon">✎</span>
                </div>
              ) : (
                <div className="tag others" onClick={() => setIsCustomInputVisible(true)}>
                  <span className="plus-icon">＋</span> Other
                </div>
              )
            )}
            {isCustomInputVisible && (
              <div className="custom-input-tag">
                <input
                  type="text"
                  placeholder="Enter custom description"
                  value={props.customDescription}
                  onChange={(e) => {
                    if (e.target.value.length <= 50) {
                      props.setCustomDescription(e.target.value);
                      setWarning("");
                    } else {
                      setWarning("Custom description cannot exceed 50 characters.");
                    }
                  }}
                  onBlur={() => handleCustomInputSubmit()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleCustomInputSubmit();
                    }
                  }}
                  autoFocus
                />
              </div>
            )}
          </>
        )}

      </div>
      {warning && <div className="warning-message">{warning}</div>}
    </div>
  );
};

export default SubModalityWithView;
